import React from "react";
import "./BottomModal.css";
import ToggleIcon from "./ToggleIcon";

const BottomModal = (props) => {
  const { isOpen, onToggle, children, feedback } = props;
  return (
    <div className={`bottom-modal ${isOpen ? "open" : "collapsed"}`}>
      <div className="modal-content" id="ncert-modal">
        <div
        id="ncert-modal-header"
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 10px",
            cursor: "pointer",
          }}
          onClick={onToggle}
        >
          {feedback ? (
            <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
              {feedback.icon && (
                <img
                  src={feedback.icon}
                  alt="feedback-icon"
                  style={{ width: 20, marginRight: 8 }}
                />
              )}
              <p
                className="feedback"
                style={{
                  margin: 0,
                  color:
                    feedback.type === "correct"
                      ? "#079455"
                      : feedback.type === "wrong"
                      ? "#D92D20"
                      : "#000",
                  fontWeight: "normal",
                }}
              >
                {feedback.text || ""}
              </p>
            </div>
          ) : (
            <div style={{ flex: 1 }} />
          )}
          <ToggleIcon isOpen={isOpen} />
        </div>

        {isOpen && <div className="modal-body">{children}</div>}
      </div>
    </div>
  );
};

export default BottomModal;
